const billingSectionES = {
    activateTitle: "Activa tu negocio",
    activateSubtitle: "Completa tu suscripción para empezar a aceptar reservas.",
    totalSeats: "Asientos totales",
    staffSeats: "Asientos de personal",
    poweredBy: "Pagos seguros gestionados por Paddle",
}

export default billingSectionES